const notFoundData = {
    meta: {
        title: 'Page not found | Child Poverty',
    },
    title: 'Page not found',
};

export default notFoundData;
